module.exports = __webpack_public_path__ + "static/media/47_Print.2324f671.png";